import { useContext } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import moneyFormat from '../functions/moneyFormat';
import decimalToPercent from '../functions/decimalToPercent'; 
import PageTooltip from './PageTooltip';
import { TableCell } from '@mui/material';

// pass row object and showOverride flag as props
const RebateAggregateRow = ({ row, count, tableHeader, showOverride,stickyEnabled }) =>{
    // get context variables from parent 
    const {
        editRow, 
        setEditRow, 
        overrideModal, 
        setOverrideModal,
        status,
        rebateInputTypeId,
    } = useContext(PageContext);

    // global redux state for company (passed in from other route)
    const companyInfo = useSelector((state) => state.companyInfo);

    // event handler for override click
    const onOverrideClick = () =>{
        // make OverrideModal visible using state from parent 
        setOverrideModal(overrideModal => overrideModal = true);
        // pass correct row to override modal using context variable
        setEditRow(editRow => editRow = row);
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return (
        <>
            {/* map logic over all columns in row object */}
            {tableHeader.map(el =>
                // logic to apply money format to correct rows
                el['columnname'] == 'cyclenetspend' || el['columnname'] == 'cyclenetinterchange' || el['columnname'] == 'cycleincentiveamount' ?
                    <> 
                        {row[el['columnname']] == null ?
                            <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                        :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>}
                    </>
                : el['columnname'] == 'blank' ?
                <>
                    {/* Only allow override if user is a Submitter and Company is in the PENDING status */}
                    { ((status == 'Pending' || status == 'Rejected') && showOverride) ?
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        <button style={{color: process.env.REACT_APP_DARK_COLOR}} class='payout-table-button' onClick={(e)=>onOverrideClick(e)}>Override</button>
                    </TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>
                        <PageTooltip title='disabled'>
                            <button className='payout-table-button-disabled'>Override</button>   
                        </PageTooltip>
                    </TableCell>}    
                </>
                // convert to percent if rebateInputTypeId is 1
                : rebateInputTypeId == 1 && el['columnname'] == 'incentiverate' && row[el['columnname']] != null ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{decimalToPercent(row[el['columnname']])}</TableCell>
                // standard display for other cols
                : <> {row[el['columnname']] == null ?
                        <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>}
                </>
            )}
        </>
    );
}

export default RebateAggregateRow;